var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5 my-0 px-0 py-0",attrs:{"fluid":""}},[_c('q-my-stats-submenu'),_c(_vm.type,{key:_vm.agent_code + _vm.componentKey,tag:"div",staticClass:"mx-5",attrs:{"agent_code":_vm.agent_code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }